import Vue from "vue";
import TrainingList from "./TrainingList.vue";

export function load() {
  const selector = "traininglist-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(TrainingList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
